module.exports = __webpack_public_path__ + "img/on-button.745cdc39.png";